module.exports = "/images/vendor/desiigner-svg/svg/vendor/only4u.svg?a2eefa6ceed322a9275711485f7ca961";